import DialogTextField from "./DialogTextField";
import DialogItemsField from "./DialogItemsField";
import DialogNumberField from "./DialogNumberField";
import DialogSelectField from "./DialogSelectField";
import DialogUploadField from "./DialogUploadField";
import DialogDateField from "./DialogDateField";
import DialogAmountField from './DialogAmountField';
import DialogThemeField from './DialogThemeField';
import Dialog2FAField from './Dialog2FAField';
import DialogTranslatableField from './DialogTranslatableField';
import DialogArrayField from './DialogArrayField';
import DialogAssociatedField from './DialogAssociatedField';
import DialogCheckboxField from './DialogCheckboxField';
import DialogFullDateField from './DialogFullDateField';
import DialogBooleanField from './DialogBooleanField';
import DialogEntityField from './DialogEntityField';
import DialogTagsField from './DialogTagsField';
import DialogWalletArrayField from './DialogWalletArrayField';

const Fields = {
    Text: DialogTextField,
    Items: DialogItemsField,
    Number: DialogNumberField,
    Select: DialogSelectField,
    Status: DialogItemsField,
    Amount: DialogAmountField,
    Upload: DialogUploadField,
    Date: DialogDateField,
    FullDate: DialogFullDateField,
    Theme: DialogThemeField,
    Dialog2FA: Dialog2FAField,
    UploadWrap: DialogUploadField,
    Translatable: DialogTranslatableField,
    Array: DialogArrayField,
    Associated: DialogAssociatedField,
    Checkbox: DialogCheckboxField,
    Boolean: DialogBooleanField,
    Entity: DialogEntityField,
    Tags: DialogTagsField,
    SelectLabel: DialogSelectField,
    ItemsLabel: DialogItemsField,
    WalletArray: DialogWalletArrayField,
};

export default Fields;
